import { TButtonState } from '@GFTypes/GameStoreTypes/ButtonState';

export const BUTTON_STATE_DEFAULTS: TButtonState = {
    isBetIncreaseButtonActive: false,
    isBetDecreaseButtonActive: false,
    isMenuButtonActive: true,
    isSpinButtonActive: false,
    isStopButtonActive: false,
    isSkipButtonActive: false,
    isTakeButtonActive: false,
    isAutoButtonActive: true,
    isGambleButtonActive: false,
    isTurboButtonActive: false,
    isMuteButtonActive: true,
    isUnmuteButtonActive: false,
    isFullscreenButtonActive: true,
    isContinueButtonActive: false,
    isBonusBuyButtonActive: true
};
